export const listConstraintQuery = {
	path: '',
	op: 'IN',
	value: [],
	code: '',
}

export const CODES = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
